import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { bridge } from 'shared/src/utils';
import { rankingFilterAtom } from '../states/rankingFilter.atom';
import {
  GOODS_RANKING_SCREEN,
  getCommonFilterAnalytics,
} from './getCommonFilterAnalytics';

type FilterType = 'AGE' | 'PERIOD';

export const useLogClickFilter = () => {
  const filter = useAtomValue(rankingFilterAtom);

  return useCallback(
    (filterType: FilterType) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_FILTER',
        analytics: {
          SCREEN: GOODS_RANKING_SCREEN,
          ...getCommonFilterAnalytics(filter),
          FILTER_TYPE: filterType,
        },
      });
    },
    [filter],
  );
};
